import * as types from "_constants";

const initialState = {
  dialogStatus: {
    open: false,
    info: {
      title: "",
    },
  },
  notificationStatus: {
    open: false,
    message: "",
  }
}

export default function reducer(state = initialState, actions) {
  switch (actions.type) {
    case types.OPEN_DIALOG:
      return {
        ...state,
        dialogStatus: {
          ...state.dialogStatus,
          severity: actions.payload.severity || 'error',
          title: actions.payload.title || 'Error',
          open: true,
          message: actions.payload.message,
        }
      };
    case types.HIDE_DIALOG:
      return {
        ...state,
        dialogStatus: {
          ...state.dialogStatus,
          open: false,
        }
      };

    case types.SHOW_NOTIFICATION:
      return {
        ...state,
        notificationStatus: {
          open: true,
          status: actions.payload.status,
          message: actions.payload.message,
        }
      };

    case types.HIDE_NOTIFICATION:
      return {
        ...state,
        notificationStatus: {
          open: false,
          message: "",
          status: "",
        }
      };

    case types.AUTH_SIGN_OUT:
      delete state.user;
      return {
        ...state
      };

    case types.GET_ORG_WEBSITE_SUCCESS:
      console.log('actions.payload.organizationWebsite', actions.payload.organizationWebsite);
      return {
        ...state,
        organizationWebsite: actions.payload.organizationWebsite
      };

    case types.GET_ORG_WEBSITE_ERROR:
      return {
        ...state,
        error: actions.payload.error
      };

    case types.GENERATECODE_INIT:
      return {
        ...state,
        organizationSlug: actions.payload.organizationSlug
      };

    case types.GENERATECODE_SUCCESS:
      return {
        ...state,
        otp: {
          email: actions.payload.email,
          sessionId: actions.payload.sessionId,
          expiry: actions.payload.expiry
        },
      };

    default:
      return state;
  }
}
